import React, { useEffect, useState } from 'react';
import axios from "axios";
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
import './OrganizationInfoView.css';

import { apiUrl } from '../../../utility/Connections';

import FileUploaderAuto from '../../../components/fileUploader/fileUploaderAuto';
import { Typography, Layout, Divider, Button } from 'antd';
import LoadingOverlay from '../../../components/loadingOverlay/loadingOverlay';
import FormOrganization from '../../../components/formOrganization/formOrganization';
import { getFromLocalStorage } from '../../../helpers/EncryptData';
import { DeleteOutlined } from '@ant-design/icons';
const { Content } = Layout;
const { Title } = Typography;

const OrganizationInfoView = () => {

    const [showLoading, setShowLoading] = useState(false);
    const [loadingText, setLoadingText] = useState(null);
    const [mainTitle, setMainTitle] = useState("Cargar logo de la organización");
    const [fileCharged, setFileCharged] = useState(false);
    const [selectedFile, setSelectedFile] = useState("");
    const [organization, setOrganization] = useState("");
    const [orgId, setOrgId] = useState("");
    const [orgName, setOrgName] = useState("");
    const [orgLogo, setOrgLogo] = useState("");
    const [orgLogoPrev, setOrgLogoPrev] = useState("");
    const [orgEmail, setOrgEmail] = useState("");
    const [orgNit, setOrgNit] = useState("");
    const [orgWebsite, setOrgWebsite] = useState("");
    const [orgEmployees, setOrgEmployees] = useState("");
    const [orgAddress, setOrgAddress] = useState("");
    const [orgResponsibleName, setOrgResponsibleName] = useState("");
    const [orgResponsibleLastName, setOrgResponsibleLastName] = useState("");
    const [orgResponsibleTel, setOrgResponsibleTel] = useState("");
    const [orgResponsibleEmail, setOrgResponsibleEmail] = useState("");
    const [orgServices, setOrgServices] = useState(false);
    const [orgActive, setOrgActive] = useState(false);

    useEffect(() => {
        const current_org = getFromLocalStorage("current_org");
        if (current_org) {
            getOrganization(current_org.org_id);
        }
    }, []); 

    const getOrganization = (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando información de la organización...")
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios.get(`${apiUrl}/organizations/get-organization-by-id/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data;
                setOrganization(data)
                setOrgId(data.org_id);
                setOrgName(data.org_name);
                setOrgEmail(data.org_email);
                setOrgNit(data.org_nit);
                setOrgWebsite(data.org_website);
                setOrgEmployees(data.org_employees);
                setOrgAddress(data.org_address);
                setOrgResponsibleName(data.org_responsible_name);
                setOrgResponsibleLastName(data.org_responsible_last_name);
                setOrgResponsibleTel(data.org_responsible_tel);
                setOrgResponsibleEmail(data.org_responsible_email);
                setOrgActive(data.org_active);
                setOrgServices(data.services);
                // setOrgUsrId(data.org_usr_id);
                setShowLoading(false);

                if (data.org_logo) {
                    getOrganizationLogo(orgId);
                }
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    const getOrganizationLogo = (orgId) => {
        setShowLoading(true);
        setLoadingText("Cargando logo de la organización...")
        const token = localStorage.getItem('access_token');
        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            },
        }
        axios.get(`${apiUrl}/organizations/get-organization-logo/${orgId}/`, headers)
            .then(function (response) {
                const data = response.data.org_logo;
                setOrgLogo(data);
                setShowLoading(false);
            })
            .catch(function (error) {
                console.error('There was an error!', error);
                setShowLoading(false);
            });
    }

    const editOrganization = () => {
        setShowLoading(true);
        setLoadingText("Guardando edición de organización...")
        const token = localStorage.getItem('access_token');

        // const newFile = selectedFile;

        const formData = new FormData();
        formData.append("org_id", orgId);
        formData.append("org_name", orgName);
        formData.append("org_email", orgEmail);
        formData.append("org_nit", orgNit);
        formData.append("org_website", orgWebsite);
        formData.append("org_employees", orgEmployees);
        formData.append("org_address", orgAddress);
        formData.append("org_responsible_name", orgResponsibleName);
        formData.append("org_responsible_last_name", orgResponsibleLastName);
        formData.append("org_responsible_tel", orgResponsibleTel);
        formData.append("org_responsible_email", orgResponsibleEmail);
        formData.append("org_active", orgActive ? "true" : "false"); // Convertir booleano a string

        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        }

        axios
            .put(`${apiUrl}/organizations/update/`, formData, headers)
            .then(function (response) {
                setOrganization(response.data.data);
                showSwal(response.data.message, 2, "Correcto");
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false)
                showSwal(`Error: ${error}`, 0, "Error");
            });
    }

    const updateOrganizationService = (ros_id, checked) => {
        // 
        setShowLoading(true);
        setLoadingText("Guardando estado del servicio...")
        const token = localStorage.getItem('access_token');

        // const newFile = selectedFile;

        const formData = new FormData();
        formData.append("ros_id", ros_id);
        formData.append("ros_active", checked);

        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            },
        }

        axios
            .put(`${apiUrl}/rel-org-srv/update-rel-org-srv/`, formData, headers)
            .then(function (response) {
                setOrganization(response.data.data);
                showSwal(response.data.message, 2, "Correcto");
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false)
                showSwal(`Error: ${error}`, 0, "Error");
            });
    }

    const showSwal = (text, type, title) => {
        let swalType = "";
        if (type === 0) {
            swalType = "error";
        }
        if (type === 1) {
            swalType = "warning";
        }
        if (type === 2) {
            swalType = "success";
        }
        withReactContent(Swal).fire({
            title: title,
            icon: swalType,
            text: text,
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        })
    }

    const selectFile = (files) => {
        setSelectedFile(files[0])
        let archivo = files[0];
        let reader = new FileReader();
        reader.onloadend = function () {
            setOrgLogoPrev(reader.result)
            setFileCharged(true)
        }
        reader.readAsDataURL(archivo);
    }

    const uploadLogo = () => {
        setShowLoading(true);
        setLoadingText("Subiendo logo de la organización...")
        const token = localStorage.getItem('access_token');
        const formData = new FormData();
        formData.append("org_id", orgId);
        formData.append("org_logo", selectedFile);

        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`,
                'Content-Type': 'multipart/form-data',
            }
        }

        axios
            .put(`${apiUrl}/organizations/update-organization-logo/`, formData, headers)
            .then(function (response) {
                setOrgLogo(response.data.file_path);
                showSwal(response.data.message, 2, "Correcto");
                setSelectedFile("");
                setFileCharged(false);
                setOrgLogoPrev("");
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false)
                showSwal(`Error: ${error}`, 0, "Error");
            });
    }

    const deleteLogo = () => {
        setShowLoading(true);
        setLoadingText("Eliminando logo de la organización...")
        const token = localStorage.getItem('access_token');

        const headers = {
            headers: {
                'Authorization': `Bearer ${token}`
            }
        }

        axios
            .get(`${apiUrl}/organizations/delete-organization-logo/${orgId}/`, headers)
            .then(function (response) {
                setOrgLogo("");
                showSwal(response.data.message, 2, "Correcto");
                setShowLoading(false);
            })
            .catch(function (error) {
                setShowLoading(false)
                showSwal(`Error: ${error}`, 0, "Error");
            });
    }

    const confirmDeleteLogo = () => {
        withReactContent(Swal).fire({
            title: "Eliminar logo de la organización",
            icon: "warning",
            text: "¿Está seguro que desea eliminar el logo de la organización?",
            showCancelButton: true,
            confirmButtonText: "Sí",
            cancelButtonText: "No",
            confirmButtonColor: "#012E40",
            cancelButtonColor: "#FF4D4F",
        }).then((result) => {
            if (result.isConfirmed) {
                deleteLogo();
            }
        })
    }

    return <div className='main-container'>
        {
            showLoading && <LoadingOverlay text={loadingText} showProgress={false} progress={null} />
        }
        <Content className='main-subcontainer main-subcontainer-column'>
            <div className='layout-content'>
                {
                    !orgLogo && !fileCharged && <Title level={5} className='main-title'>{mainTitle}</Title>
                }
                {
                    orgLogo || fileCharged ? <div className='organization-logo-container'>
                        <img
                            src={fileCharged ? orgLogoPrev : orgLogo}
                            alt="Logo de la organización"
                            className='organization-logo'
                        />
                        {
                            fileCharged && <div className='organization-logo-buttons'>
                                <Button danger onClick={() => setFileCharged(false)}>Cambiar logo</Button>
                                <Button style={{ marginLeft: 20 }} type="primary" onClick={uploadLogo}>Guardar logo</Button>
                            </div>
                        }
                        {
                            orgLogo && !fileCharged && <Button style={{ marginTop: 20 }} danger icon={<DeleteOutlined />} onClick={confirmDeleteLogo}>Eliminar logo</Button>
                        }
                    </div> : <FileUploaderAuto 
                        mostrarData={selectFile} 
                        multi={false} 
                        openSwal={showSwal} 
                        uploadFile={false} 
                        uploadImagen={true} 
                        tamanoArchivo={1} 
                    />
                }
                
            </div>
            <Divider />
            <div className='layout-content'>
                <FormOrganization
                    editOrganization={editOrganization}
                    updateOrganizationService={updateOrganizationService}
                    orgName={orgName}
                    orgLogo={orgLogo}
                    orgEmail={orgEmail}
                    orgNit={orgNit}
                    orgWebsite={orgWebsite}
                    orgEmployees={orgEmployees}
                    orgAddress={orgAddress}
                    orgResponsibleName={orgResponsibleName}
                    orgResponsibleLastName={orgResponsibleLastName}
                    orgResponsibleTel={orgResponsibleTel}
                    orgResponsibleEmail={orgResponsibleEmail}
                    orgActive={orgActive}
                    orgServices={orgServices}
                    setOrgId={setOrgId}
                    setOrgName={setOrgName}
                    setOrgLogo={setOrgLogo}
                    setOrgEmail={setOrgEmail}
                    setOrgNit={setOrgNit}
                    setOrgWebsite={setOrgWebsite}
                    setOrgEmployees={setOrgEmployees}
                    setOrgAddress={setOrgAddress}
                    setOrgResponsibleName={setOrgResponsibleName}
                    setOrgResponsibleLastName={setOrgResponsibleLastName}
                    setOrgResponsibleTel={setOrgResponsibleTel}
                    setOrgResponsibleEmail={setOrgResponsibleEmail}
                    setOrgServices={setOrgServices}
                    setOrgActive={setOrgActive}
                />
            </div>
        </Content>
    </div>
}

export default OrganizationInfoView;